export default {
    ultimasInternacoes: {
        dados: {
            profissionalValidacao: null,
            ultimaDataHoraValidacao: null,
            profissionalUltimaInternacao: null,
            ultimaDataHoraInternacao: null
        }
    }
}
